import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is it paper or digital?',
  a: 'It is a 100% digital product (High-Resolution PDF) that combines 6 guides in 1, optimized for viewing on iPad, Tablet, or Smartphone during your classes.'
}, {
  q: 'Do I need to be an expert to use it?',
  a: 'Not at all. YOGA READY™ is designed for instructors at every stage — whether you completed your teacher training last month or have been teaching for years.'
}, {
  q: 'Does it work for studio and online classes?',
  a: 'Yes. Every sequence, template and resource inside YOGA READY™ is designed to work in a physical studio, a home setup or a live online class format.'
}, {
  q: 'Is this a one-time payment or a subscription?',
  a: 'It is a one-time payment. You pay $27 once and get lifetime access to the entire YOGA READY™ system and all bonuses. No hidden fees or recurring charges.'
}, {
  q: 'Do I get access to the bonuses immediately?',
  a: 'Yes! All 5 luxury bonuses are included with your purchase today and will be delivered instantly alongside the main system.'
}, {
  q: 'Can I print the PDFs?',
  a: 'Absolutely. All guides and resources are printer-friendly. Many instructors like to print the sequences and keep them in a binder at the studio.'
}, {
  q: 'What styles of yoga does this cover?',
  a: 'The sequences and poses are highly adaptable, focusing primarily on Vinyasa, Hatha, and Restorative styles. The Class Builder System allows you to adjust the intensity for any format.'
}, {
  q: 'How fast can I use this in my next class?',
  a: 'Immediately. You can open the Professional Sequences guide, pick a 60-minute class, review the cues, and teach it today. Zero prep time required.'
}, {
  q: 'What is the refund process if I am not satisfied?',
  a: 'Simply email us within 7 days of your purchase, and we will issue a full, no-questions-asked refund. Your investment is 100% risk-free.'
}, {
  q: 'Do I need specific props or equipment?',
  a: 'The core sequences require only a mat. We do include cueing for optional blocks and straps in the Substitution Guide to help accommodate all student levels.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-41">
      <div className="max-w-3xl mx-auto" data-id="element-42">
        <div className="text-center mb-6" data-id="element-43">
          <h2 className="text-2xl sm:text-3xl font-serif font-extrabold text-brand-graphite mb-1 uppercase" data-id="element-44">
            FREQUENTLY ASKED QUESTIONS
          </h2>
        </div>

        <div className="space-y-2" data-id="element-45">
          {faqs.map((faq, i) => <div key={i} className="bg-white border-2 border-brand-gold/30 rounded-lg overflow-hidden shadow-sm" data-id="element-46">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3 text-left flex justify-between items-center hover:bg-brand-cream/50 transition-colors gap-3" data-id="element-47">
                <span className="font-bold text-brand-graphite text-sm sm:text-base leading-snug" data-id="element-48">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-petrol transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>

              {openIndex === i && <div className="px-4 pb-3 pt-0 text-brand-graphite/80 font-medium text-sm leading-snug" data-id="element-50">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}